// src/Screens/MyRooms.jsx
// The full My Rooms list, opened from the My Rooms sheet on Home ("View all")
// and kept at /my-rooms for old bookmarks. It sits inside the app shell, so
// the header and tabs stay, with a back button to Home.
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import MyRoomsContent from "./MyRoomsContent";

const MyRooms = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="container mx-auto px-6 pt-4 -mb-6">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="-ml-3 flex items-center gap-1.5 min-h-[44px] px-3 rounded-full text-sm font-semibold text-brand-text hover:bg-brand-accentMuted transition-colors"
        >
          <ArrowLeft size={18} aria-hidden="true" />
          Home
        </button>
      </div>
      <MyRoomsContent />
    </div>
  );
};

export default MyRooms;
